import { BaseListModel } from "./baseListModel";

export class ListItemModel extends BaseListModel {

}